<template>
  <a-card title="版本详情">
    <template #extra><a @click="() => history.go(-1)">返回</a></template>
    <a-descriptions bordered>
      <a-descriptions-item label="歌曲名称">{{ formState.name }}</a-descriptions-item>
      <a-descriptions-item label="歌曲识别码">{{ formState.song_code }}</a-descriptions-item>
      <a-descriptions-item label="歌曲简拼">{{ formState.py }}</a-descriptions-item>
      <a-descriptions-item label="所属教材">{{ formState.book?.name || '--' }}</a-descriptions-item>
      <a-descriptions-item label="所属章节">{{ formState.section?.name || '--' }}</a-descriptions-item>
      <a-descriptions-item label="歌曲类型">
        <a-tag :color="songType.get(formState.song_type).presetColor">
          {{ songType.get(formState.song_type).name }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="谱例类型">
        <a-tag>{{ songSheetType[formState.sheet_type].name }}</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="歌曲速度">{{ formState.speed }}</a-descriptions-item>
      <a-descriptions-item label="曲谱文件地址">{{ formState.evxml_file_url }}</a-descriptions-item>
      <a-descriptions-item label="曲谱文件md5">{{ formState.evxml_file_md5 }}</a-descriptions-item>
      <a-descriptions-item label="曲谱文件大小">{{ formState.evxml_file_size }}</a-descriptions-item>
      <a-descriptions-item label="evms文件地址">{{ formState.evms_file_url }}</a-descriptions-item>
      <a-descriptions-item label="evms文件md5">{{ formState.evms_file_md5 }}</a-descriptions-item>
      <a-descriptions-item label="evms文件大小">{{ formState.evms_file_size }}</a-descriptions-item>
      <a-descriptions-item label="原唱文件地址">{{ formState.ori_file_url }}</a-descriptions-item>
      <a-descriptions-item label="原唱文件md5">{{ formState.ori_file_md5 }}</a-descriptions-item>
      <a-descriptions-item label="原唱文件大小">{{ formState.ori_file_size }}</a-descriptions-item>
      <a-descriptions-item label="伴唱文件地址">{{ formState.acc_file_url }}</a-descriptions-item>
      <a-descriptions-item label="伴唱文件md5">{{ formState.acc_file_md5 }}</a-descriptions-item>
      <a-descriptions-item label="伴唱文件大小">{{ formState.acc_file_size }}</a-descriptions-item>
      <a-descriptions-item label="伴唱速度">{{ formState.acc_speed }}</a-descriptions-item>
      <a-descriptions-item label="标签">
        <span v-if="!formState.tags?.length">--</span>
        <div v-if="formState.tags.length">
          <a-tag :key="item.tag" v-for="item in formState.tags">{{ item.tag }}</a-tag>
        </div>
      </a-descriptions-item>
      <a-descriptions-item label="歌曲图片列表" :span="3">
        <a-image-preview-group>
          <span
            v-for="item in formState.picture_url"
            style="margin-right: 12px"
            :key="item"
          >
            <a-image
              :width="200"
              :height="200"
              :src="item"
              :fallback="config.fallbackImg"
            />
          </span>
        </a-image-preview-group>
      </a-descriptions-item>
    </a-descriptions>
  </a-card>
</template>

<script>
import { useRoute } from 'vue-router'
import { ref, onBeforeMount } from 'vue'
import { getOfficialSheetSongVersionInfo } from '@/services/songs'
import config from '@/config'
import { songType, songSheetType } from '@/utils/dataMap/song'

export default {
  name: 'VersionDetail',
  setup () {
    const route = useRoute()
    const formState = ref({
      song_type: 0,
      sheet_type: 0,
      tags: []
    })
    onBeforeMount(async () => {
      formState.value = await getOfficialSheetSongVersionInfo(route.params.versionId)
    })

    return {
      history,
      formState,
      config,
      songType,
      songSheetType
    }
  }
}
</script>

<style scoped>

</style>
